import type { BalanceFragment } from "@workspace/casino_core/queries/UserBalanceQuery";
import { useEffect, useRef, useState } from "react";

type Args = {
  balance?: BalanceFragment;
};

const useDelayedBalance = ({ balance }: Args) => {
  const [oldBalance, setOldBalance] = useState(0);
  const [delayedBalance, setDelayedBalance] = useState<BalanceFragment>();
  const timeout = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    const newBalance = balance?.totalBalance;
    if (newBalance) {
      setOldBalance(newBalance);
      if (oldBalance === 0 || oldBalance > newBalance) {
        setDelayedBalance(balance);
      } else if (oldBalance < newBalance) {
        timeout.current = setTimeout(() => {
          setDelayedBalance(balance);
        }, 5000);
      }
    }

    return () => {
      if (newBalance && (oldBalance === 0 || oldBalance > newBalance)) {
        clearTimeout(timeout.current);
      }
    };
  }, [balance, oldBalance]);

  return delayedBalance;
};

export default useDelayedBalance;
